import React from 'react';

/* ── SVGs de silueta lateral para cada tipo de unidad ── */

const SvgCamioneta = () => (
  <svg viewBox="0 0 96 44" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    {/* Cabina */}
    <rect x="6" y="14" width="26" height="18" rx="3" fill="#3b82f6"/>
    {/* Techo cabina */}
    <rect x="10" y="9" width="17" height="8" rx="2" fill="#2563eb"/>
    {/* Parabrisas */}
    <rect x="24" y="11" width="6" height="7" rx="1" fill="#bfdbfe"/>
    {/* Ventana lateral */}
    <rect x="12" y="11" width="10" height="6" rx="1" fill="#bfdbfe"/>
    {/* Caja de carga */}
    <rect x="32" y="18" width="38" height="14" rx="2" fill="#2563eb"/>
    {/* Franja superior caja */}
    <rect x="32" y="16" width="38" height="3" rx="1" fill="#1d4ed8"/>
    {/* Bumper frontal */}
    <rect x="2" y="26" width="5" height="5" rx="1" fill="#1d4ed8"/>
    {/* Rueda delantera */}
    <circle cx="18" cy="34" r="7" fill="#1e293b"/>
    <circle cx="18" cy="34" r="3.5" fill="#64748b"/>
    <circle cx="18" cy="34" r="1.5" fill="#94a3b8"/>
    {/* Rueda trasera */}
    <circle cx="58" cy="34" r="7" fill="#1e293b"/>
    <circle cx="58" cy="34" r="3.5" fill="#64748b"/>
    <circle cx="58" cy="34" r="1.5" fill="#94a3b8"/>
    {/* Línea de suelo */}
    <line x1="0" y1="41" x2="96" y2="41" stroke="#e2e8f0" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

const SvgRabon = () => (
  <svg viewBox="0 0 96 44" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    {/* Cuerpo principal (nariz chata) */}
    <rect x="4" y="10" width="28" height="22" rx="3" fill="#3b82f6"/>
    {/* Parabrisas */}
    <rect x="26" y="13" width="5" height="8" rx="1" fill="#bfdbfe"/>
    {/* Ventana lateral */}
    <rect x="12" y="13" width="12" height="6" rx="1" fill="#bfdbfe"/>
    {/* Caja de carga larga */}
    <rect x="32" y="8" width="58" height="24" rx="2" fill="#2563eb"/>
    {/* Bisagra/unión */}
    <rect x="30" y="10" width="4" height="20" fill="#1d4ed8"/>
    {/* Detalle lateral caja */}
    <line x1="34" y1="14" x2="88" y2="14" stroke="#1d4ed8" strokeWidth="1.5"/>
    <line x1="34" y1="28" x2="88" y2="28" stroke="#1d4ed8" strokeWidth="1.5"/>
    {/* Bumper */}
    <rect x="1" y="24" width="4" height="5" rx="1" fill="#1d4ed8"/>
    {/* Rueda delantera */}
    <circle cx="16" cy="35" r="7" fill="#1e293b"/>
    <circle cx="16" cy="35" r="3.5" fill="#64748b"/>
    <circle cx="16" cy="35" r="1.5" fill="#94a3b8"/>
    {/* Rueda trasera doble */}
    <circle cx="70" cy="35" r="7" fill="#1e293b"/>
    <circle cx="70" cy="35" r="3.5" fill="#64748b"/>
    <circle cx="70" cy="35" r="1.5" fill="#94a3b8"/>
    <circle cx="80" cy="35" r="7" fill="#1e293b"/>
    <circle cx="80" cy="35" r="3.5" fill="#64748b"/>
    <circle cx="80" cy="35" r="1.5" fill="#94a3b8"/>
    {/* Línea de suelo */}
    <line x1="0" y1="41" x2="96" y2="41" stroke="#e2e8f0" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

const SvgTorton = () => (
  <svg viewBox="0 0 96 44" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    {/* Cabina separada */}
    <rect x="2" y="12" width="22" height="20" rx="2" fill="#3b82f6"/>
    {/* Techo cabina */}
    <rect x="4" y="8" width="18" height="6" rx="2" fill="#2563eb"/>
    {/* Parabrisas */}
    <rect x="18" y="10" width="5" height="9" rx="1" fill="#bfdbfe"/>
    {/* Ventana lateral */}
    <rect x="6" y="10" width="10" height="6" rx="1" fill="#bfdbfe"/>
    {/* Estribos */}
    <rect x="4" y="30" width="18" height="2" rx="1" fill="#1d4ed8"/>
    {/* Caja de carga separada */}
    <rect x="26" y="9" width="66" height="23" rx="2" fill="#2563eb"/>
    {/* Detalles caja */}
    <line x1="28" y1="15" x2="90" y2="15" stroke="#1d4ed8" strokeWidth="1"/>
    <line x1="28" y1="28" x2="90" y2="28" stroke="#1d4ed8" strokeWidth="1"/>
    <line x1="55" y1="9" x2="55" y2="32" stroke="#1d4ed8" strokeWidth="0.8" strokeDasharray="3,3"/>
    {/* Bumper */}
    <rect x="0" y="25" width="3" height="5" rx="1" fill="#1d4ed8"/>
    {/* Rueda delantera */}
    <circle cx="12" cy="35" r="7" fill="#1e293b"/>
    <circle cx="12" cy="35" r="3.5" fill="#64748b"/>
    <circle cx="12" cy="35" r="1.5" fill="#94a3b8"/>
    {/* Ruedas traseras dobles */}
    <circle cx="67" cy="35" r="7" fill="#1e293b"/>
    <circle cx="67" cy="35" r="3.5" fill="#64748b"/>
    <circle cx="67" cy="35" r="1.5" fill="#94a3b8"/>
    <circle cx="77" cy="35" r="7" fill="#1e293b"/>
    <circle cx="77" cy="35" r="3.5" fill="#64748b"/>
    <circle cx="77" cy="35" r="1.5" fill="#94a3b8"/>
    {/* Línea de suelo */}
    <line x1="0" y1="41" x2="96" y2="41" stroke="#e2e8f0" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

const SvgTrailer = () => (
  <svg viewBox="0 0 120 44" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    {/* Cabina tractocamión */}
    <rect x="2" y="13" width="20" height="19" rx="2" fill="#3b82f6"/>
    {/* Techo + alerón */}
    <rect x="4" y="8" width="16" height="7" rx="2" fill="#2563eb"/>
    <rect x="14" y="6" width="8" height="4" rx="1" fill="#1d4ed8"/>
    {/* Parabrisas */}
    <rect x="17" y="10" width="4" height="9" rx="1" fill="#bfdbfe"/>
    {/* Ventana */}
    <rect x="5" y="10" width="10" height="6" rx="1" fill="#bfdbfe"/>
    {/* Estribo */}
    <rect x="4" y="30" width="16" height="1.5" rx="0.5" fill="#1d4ed8"/>
    {/* Remolque largo */}
    <rect x="22" y="10" width="94" height="22" rx="2" fill="#2563eb"/>
    {/* Detalles remolque */}
    <line x1="24" y1="16" x2="114" y2="16" stroke="#1d4ed8" strokeWidth="1"/>
    <line x1="24" y1="28" x2="114" y2="28" stroke="#1d4ed8" strokeWidth="1"/>
    <line x1="55" y1="10" x2="55" y2="32" stroke="#1d4ed8" strokeWidth="0.6" strokeDasharray="3,3"/>
    <line x1="85" y1="10" x2="85" y2="32" stroke="#1d4ed8" strokeWidth="0.6" strokeDasharray="3,3"/>
    {/* Quinta rueda / enganche */}
    <rect x="20" y="30" width="5" height="3" rx="1" fill="#94a3b8"/>
    {/* Bumper */}
    <rect x="0" y="26" width="3" height="4" rx="1" fill="#1d4ed8"/>
    {/* Rueda delantera camión */}
    <circle cx="11" cy="35" r="7" fill="#1e293b"/>
    <circle cx="11" cy="35" r="3.5" fill="#64748b"/>
    <circle cx="11" cy="35" r="1.5" fill="#94a3b8"/>
    {/* Ruedas traseras camión */}
    <circle cx="30" cy="35" r="6.5" fill="#1e293b"/>
    <circle cx="30" cy="35" r="3" fill="#64748b"/>
    <circle cx="38" cy="35" r="6.5" fill="#1e293b"/>
    <circle cx="38" cy="35" r="3" fill="#64748b"/>
    {/* Ruedas traseras remolque */}
    <circle cx="96" cy="35" r="6.5" fill="#1e293b"/>
    <circle cx="96" cy="35" r="3" fill="#64748b"/>
    <circle cx="104" cy="35" r="6.5" fill="#1e293b"/>
    <circle cx="104" cy="35" r="3" fill="#64748b"/>
    {/* Línea de suelo */}
    <line x1="0" y1="41" x2="120" y2="41" stroke="#e2e8f0" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

const SvgTrailerRefrigerado = () => (
  <svg viewBox="0 0 120 44" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    {/* Cabina tractocamión */}
    <rect x="2" y="13" width="20" height="19" rx="2" fill="#3b82f6"/>
    <rect x="4" y="8" width="16" height="7" rx="2" fill="#2563eb"/>
    <rect x="14" y="6" width="8" height="4" rx="1" fill="#1d4ed8"/>
    <rect x="17" y="10" width="4" height="9" rx="1" fill="#bfdbfe"/>
    <rect x="5" y="10" width="10" height="6" rx="1" fill="#bfdbfe"/>
    <rect x="4" y="30" width="16" height="1.5" rx="0.5" fill="#1d4ed8"/>
    {/* Remolque */}
    <rect x="22" y="10" width="94" height="22" rx="2" fill="#2563eb"/>
    {/* Unidad refrigerante (caja al frente del remolque) */}
    <rect x="22" y="6" width="12" height="6" rx="1.5" fill="#1d4ed8"/>
    <rect x="23" y="7" width="10" height="4" rx="1" fill="#0ea5e9"/>
    {/* Franjas de frío (líneas horizontales distintivas) */}
    <line x1="34" y1="14" x2="114" y2="14" stroke="#e0f2fe" strokeWidth="1.5"/>
    <line x1="34" y1="18" x2="114" y2="18" stroke="#e0f2fe" strokeWidth="1.5"/>
    <line x1="34" y1="22" x2="114" y2="22" stroke="#e0f2fe" strokeWidth="1.5"/>
    <line x1="34" y1="26" x2="114" y2="26" stroke="#e0f2fe" strokeWidth="1.5"/>
    <line x1="34" y1="30" x2="114" y2="30" stroke="#e0f2fe" strokeWidth="1.5"/>
    {/* Quinta rueda */}
    <rect x="20" y="30" width="5" height="3" rx="1" fill="#94a3b8"/>
    {/* Bumper */}
    <rect x="0" y="26" width="3" height="4" rx="1" fill="#1d4ed8"/>
    {/* Ruedas */}
    <circle cx="11" cy="35" r="7" fill="#1e293b"/>
    <circle cx="11" cy="35" r="3.5" fill="#64748b"/>
    <circle cx="11" cy="35" r="1.5" fill="#94a3b8"/>
    <circle cx="30" cy="35" r="6.5" fill="#1e293b"/>
    <circle cx="30" cy="35" r="3" fill="#64748b"/>
    <circle cx="38" cy="35" r="6.5" fill="#1e293b"/>
    <circle cx="38" cy="35" r="3" fill="#64748b"/>
    <circle cx="96" cy="35" r="6.5" fill="#1e293b"/>
    <circle cx="96" cy="35" r="3" fill="#64748b"/>
    <circle cx="104" cy="35" r="6.5" fill="#1e293b"/>
    <circle cx="104" cy="35" r="3" fill="#64748b"/>
    {/* Línea de suelo */}
    <line x1="0" y1="41" x2="120" y2="41" stroke="#e2e8f0" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

const TIPOS_CONFIG = {
  'Camioneta':           { svg: SvgCamioneta,           label: 'Camioneta',            desc: 'Carga ligera · hasta 1.5 tons',    color: 'bg-sky-50 border-sky-200',       textColor: 'text-sky-700' },
  'Rabon':               { svg: SvgRabon,                label: 'Rabón',                desc: 'Carga media · hasta 8 tons',       color: 'bg-blue-50 border-blue-200',     textColor: 'text-blue-700' },
  'Torton':              { svg: SvgTorton,               label: 'Tortón',               desc: 'Carga pesada · hasta 18 tons',     color: 'bg-indigo-50 border-indigo-200', textColor: 'text-indigo-700' },
  'Trailer':             { svg: SvgTrailer,              label: 'Trailer',              desc: 'Carga extra pesada · hasta 25 tons', color: 'bg-violet-50 border-violet-200', textColor: 'text-violet-700' },
  'Trailer Refrigerado': { svg: SvgTrailerRefrigerado,   label: 'Trailer Refrigerado',  desc: 'Cadena de frío · hasta 22 tons',  color: 'bg-cyan-50 border-cyan-200',     textColor: 'text-cyan-700' },
};

export default function TipoUnidadBadge({ tipo, marcaModelo, foto, gpsInstalado, largoM, anchoM, altoM, seguroCarga, tempMinima }) {
  const cfg = TIPOS_CONFIG[tipo] || TIPOS_CONFIG['Trailer'];
  const Svg = cfg.svg;

  const tieneDimensiones = largoM || anchoM || altoM;
  const dimStr = tieneDimensiones
    ? [largoM && `${largoM}m largo`, anchoM && `${anchoM}m ancho`, altoM && `${altoM}m alto`].filter(Boolean).join(' · ')
    : null;

  return (
    <div className={`rounded-xl border ${cfg.color} mt-3 mb-1 overflow-hidden`}>
      {/* Fila principal: foto o SVG + tipo + badges */}
      <div className="flex items-center gap-3 px-4 py-2.5">
        {foto
          ? <img src={foto} alt={cfg.label} className="w-20 h-12 object-cover rounded-lg flex-shrink-0 border border-white/60 shadow-sm" />
          : <div className="w-20 h-8 flex-shrink-0"><Svg /></div>
        }
        <div className="min-w-0 flex-1">
          <p className={`font-bold text-sm leading-tight ${cfg.textColor}`}>{cfg.label}</p>
          <p className="text-xs text-gray-500 leading-tight">{cfg.desc}</p>
          {marcaModelo && <p className="text-xs text-gray-400 leading-tight truncate">{marcaModelo}</p>}
        </div>
        {/* Badges GPS / Seguro / Temp */}
        <div className="flex flex-col gap-1 flex-shrink-0 items-end">
          {gpsInstalado && (
            <span className="inline-flex items-center gap-1 px-1.5 py-0.5 bg-green-100 text-green-700 text-[10px] font-semibold rounded-full">
              📡 GPS
            </span>
          )}
          {seguroCarga && (
            <span className="inline-flex items-center gap-1 px-1.5 py-0.5 bg-blue-100 text-blue-700 text-[10px] font-semibold rounded-full">
              🛡 Seguro
            </span>
          )}
          {tempMinima != null && (
            <span className="inline-flex items-center gap-1 px-1.5 py-0.5 bg-cyan-100 text-cyan-700 text-[10px] font-semibold rounded-full">
              ❄️ {tempMinima}°C
            </span>
          )}
        </div>
      </div>
      {/* Fila de dimensiones (solo si existen) */}
      {dimStr && (
        <div className="px-4 pb-2.5">
          <span className="text-xs text-gray-400">📐 {dimStr}</span>
        </div>
      )}
    </div>
  );
}
